import {
  DataModelBuilder, isSameData, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';
import { CustomInfo } from '../../models/serializable/custom-info.js';

export class CustomInfoComponent extends Component {
  static readonly TYPE_ID: string = 'f50b6b4c137047e68d5d2c32b8a3b3a0';

  constructor(
    public readonly customInfo: CustomInfo,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return CustomInfoComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CustomInfoComponent {
    return new CustomInfoComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'customInfo'))
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'customInfo': context.toData(this.customInfo),
    };
  }

  clone(): this {
    return new CustomInfoComponent(
        this.customInfo.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.customInfo, this.customInfo);
  }
}

export class CustomInfoComponentBuilder extends DataModelBuilder<CustomInfoComponent> {
  build(context: SerializationContext, map: SerializedData): CustomInfoComponent {
    return CustomInfoComponent.fromMap(context, map);
  }
}
